module.exports = __webpack_public_path__ + "media/images/favicon-2e84bcc5b68601b806b7ae22d6ab3935.svg";